import React from 'react';
import Image from 'next/image';
import Link from 'next/link';

const Hero = () => {
  return (
    <section className="relative bg-black text-white min-h-[85vh] flex items-center justify-start px-6 overflow-hidden border-b border-gray-900">
      <div className="absolute inset-0">
        <Image
          src="/austin-skyline.jpg"
          alt=""
          fill
          className="object-cover opacity-20"
          priority
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-3xl flex flex-col gap-8 py-24">
        <div className="w-[180px] h-[90px] relative">
          <Image
            src="/ktr_logo_onblack.svg"
            alt="KTR Capital"
            width={180}
            height={90}
            priority
          />
        </div>

        <div className="space-y-6">
          <div className="text-xs uppercase tracking-[0.2em] text-orange-400">
            KTR Capital — Austin, Texas
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-light leading-[1.1] tracking-tight">
            Investing in{' '}
            <span className="text-orange-400 font-normal">science</span>{' '}and{' '}
            <span className="text-orange-400 font-normal">technology</span>.
          </h1>
        </div>

        <p className="text-lg text-gray-400 leading-relaxed max-w-2xl font-light">
          A private investment firm built around a physician-led biotech edge and proprietary
          trading technology. KTR Capital offers accredited investors institutional access across
          biotech, quantitative trading, and private equity — in a single fund.
        </p>

        <div className="flex flex-col sm:flex-row items-start gap-4 pt-4">
          <Link
            href="/sign-up"
            className="inline-flex items-center gap-3 bg-orange-500 text-black px-6 py-3 rounded font-medium hover:bg-orange-600 transition-colors"
          >
            Sign up
            <span aria-hidden="true">→</span>
          </Link>
          <Link
            href="/sign-in"
            className="inline-flex items-center gap-2 text-gray-300 hover:text-white px-6 py-3 text-sm font-light border border-gray-700 rounded"
          >
            Investor sign in
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Hero;
